<script>
    import { onMount } from 'svelte';
    import { appSettings, personen } from "../stores";
    import Swiper from "../components/swiper/Swiper.svelte";
    import SwiperSlide from "../components/swiper/SwiperSlide.svelte";
    import Thumbnail from "../components/personen/Thumbnail.svelte";

    onMount ( () => {
        $appSettings.currentPageLink = "/personen";
        $appSettings.currentPageName = "Personen";
        $appSettings.parentPage = "/";
        $appSettings.personIndex = $appSettings.personIndex??Math.floor(Math.random() * personen.length);
        window.scrollTo(0, 0);
    })

    let dragging = false;
</script>

<h1>Deportiert aus Trier</h1>
<p>Aus Trier wurden knapp 650 Männer, Frauen und Kinder deportiert, weil sie nach der nationalsozialistischen Rassenideologie als „jüdisch“ galten. 323 von ihnen sind eingesessene Triererinnen und Trierer gewesen, die anderen wurden aus dem Umland deportiert oder waren seit November 1938 aus den umliegenden Orten und Kleinstädten nach Trier gezogen.</p>
<p>Die Auswahl der hier vorgestellten Einzelschicksale erfolgte aufgrund der guten Quellenlage zu diesen Personen – über viele andere ist leider bisher noch wenig bekannt. Um mehr über die einzelnen Personen zu erfahren, tippe sie an.</p>
<!-- <div class="gallery">
    <Swiper bind:activeSlide={$appSettings.personIndex} bind:dragging={dragging}> -->
        {#each personen as person}
        <!-- <SwiperSlide> -->
            <Thumbnail {...person}/>
            <br>
        <!-- </SwiperSlide> -->
        {/each}
    <!-- </Swiper>
</div> -->
<p>Die gezeigten Bilder sind größtenteils sogenannte „Kennkarten“. Diese wurden im Deutschen Reich 1938 als „Inlandausweis“ eingeführt und konnten von allen deutschen Staatsangehörigen beantragt werden. Jüdinnen und Juden hingegen mussten zwangsweise eine mit einem „J“ versehene Kennkarte immer bei sich tragen, um sich auszuweisen. Auch die auf diesen Kennkarten eingefügten Passfotos sind nicht freiwillig entstanden. Außerdem erkennbar ist die ab Januar 1939 eingeführte Pflicht, die Zwangsnamen Sara bzw. Israel zusätzlich zum eigenen Vornamen zu tragen. Diese wurden auch in die amtlichen Dokumente aufgenommen. Als Teil des Ausgrenzungs- und Entrechtungsprozesses der jüdischen Bevölkerung gingen diese Maßnahmen den Deportationen voraus.</p>
<!-- <button>alle ansehen</button> -->


<style>
    .gallery {
        margin-left: -2rem;
        margin-right: -2rem;
    }
</style>